export const FIELDS_TYPE_CONSTANTS = {
  Select: "Select",
  Input: "Input",
  SearchInput: "SearchInput",
  Date: "Date",
  Number: "Number",
  DateRange: "DateRange",
  DateRange2: "DateRange2",
  TimeRange: "TimeRange",
} as const;

export const ALL_START_DATE = "2020-06-01 00:00:00";

export const DATE_FILTER_OPTIONS = [
  {
    label: "Today",
    value: "today",
  },
  {
    label: "Yesterday",
    value: "yesterday",
  },
  {
    label: "Last 7 days",
    value: "last7",
  },
  {
    label: "Last 30 days",
    value: "last30",
  },
  {
    label: "All",
    value: "all",
  },
  {
    label: "Custom",
    value: "custom",
  },
];
